import React, { Component } from "react";
import Header from "../../../Components/MainLayout/Header";

class AboutUs extends Component {
  render() {
    return (
      <div>
        <Header to="/profile" title="About Us" />
        <div className="container col-12">
          <div className="th-12 th-primary pt-2">About Us</div>
          <div className="th-12 py-2">
            blab bla blab bla blab bla blab bla blab bla blab bla blab bla blab
            bla blab bla blab bla blab bla blab bla blab bla blab bla blab bla
            blab bla blab bla blab bla blab bla blab bla blab bla blab bla blab
            bla
          </div>
        </div>
      </div>
    );
  }
}
export default AboutUs;
